import { CheckCoverageProps } from "./CheckCoverage";
import { SecondaryInfoCard } from "../../common";
import styles from "./S8_CheckCoverage.module.scss";
import { AutoComplete, SimpleModal, ButtonCust } from "../../widgets";
import EnvConfig from "../../../config/env.config.json";
import { Box, Container, Typography } from "@mui/material";
import { addressDisplayPattern } from "../../../utils/regexPatterns";
import { BrandNameUpdate, updateSvgFillColor } from "../../../utils";

const T8CheckCoverageComponent = (props: CheckCoverageProps) => {
  const {
    checkAddressHandler,
    handleSelect,
    checkCoverageHandler,
    coverageContent,
    checkAddress,
    coverageLoading,
    coverageAddress,
    signal4G,
    signal5G,
    coverageError,
    navigateCheckCoverage,
    coverageModal,
    checkDisableHandler,
    signalModal,
    openCoverageModal,
    closeModalHandler,
    searchAgainHandler,
    exploreHandler,
  } = props;

  const {
    tick_icon,
    heading,
    sub_heading,
    modal_heading,
    modal_subheading,
    place_holder,
    signal_note2,
    button_1,
    button_2,
    button_3,
    button_4,
    button_5,
    error,
    coverage_1,
    coverage_2,
    signal_strength1,
    signal_strength2,
    signal_strength3,
    signal_strength4,
    alt_image_text,
    fair_signal,
    good_signal,
    great_signal,
    no_coverage,
    no_signal_code,
    fair_signal_code,
    good_signal_code,
    great_signal_code,
    coverage_map,
    modal_heading2,
    web_img_left,
  } = coverageContent || {};
  const isCompleteAddressDisplayFormat =
    addressDisplayPattern.test(checkAddress);
  const displayAddressValue = isCompleteAddressDisplayFormat
    ? checkAddress.replace(/,(\s*\d{5})$/, "$1")
    : checkAddress;
  return (
    coverageContent && (
      <>
        <Box
          className={styles.check_coverage_container}
          minHeight={{ xs: "470px", sm: "614px", md: "320px" }}
          sx={{ padding: { xs: "20px", md: "0px" } }}
        >
          <SecondaryInfoCard
            is_right={web_img_left}
            image={coverage_map?.data?.attributes?.url}
            btnWidth="200px"
            info={sub_heading}
            title={heading}
            btnTxt={button_1}
            onclick={openCoverageModal}
            alt={coverage_map?.data?.attributes?.alternativeText}
            maxImgWidth={"362px"}
          />
        </Box>
        <SimpleModal
          isShowModal={coverageModal || signalModal}
          onCloseModal={closeModalHandler}
          showClose={true}
          className={styles.coverage_modal}
          sx={{
            width: { xs: "95%", lg: "646px", xl: "39%" },
            px: "30px !important",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        >
          {coverageModal ? (
            <>
              <Typography
                variant="h5"
                sx={{
                  my: "15px",
                  textAlign: "center",
                  fontSize: "22px !important",
                  fontWeight: "var(--font_weight_4)",
                }}
                className={styles.coverage_check_heading}
              >
                {modal_heading}
              </Typography>
              <Typography
                component="span"
                className={styles.coverage_check_subheading}
                sx={{
                  mb: "25px",
                  fontSize: "18px !important",
                  textAlign: "center",
                  fontWeight: "var(--font_weight_1) !important",
                }}
              >
                {modal_subheading}
              </Typography>
              <Box sx={{ width: { xs: "100%", lg: "500px" } }}>
                <AutoComplete
                  value={displayAddressValue}
                  onChange={checkAddressHandler}
                  onSelect={(e: any, placeId: string) => {
                    handleSelect(placeId);
                  }}
                  placeholder={place_holder}
                  autoComplete="off"
                  name="address"
                />
              </Box>
              {coverageError && (
                <Container
                  style={{ padding: 0 }}
                  className={styles.coverage_error}
                >
                  {error}
                </Container>
              )}
              <ButtonCust
                sx={{
                  mt: "40px",
                  mb: "30px",
                  width: "250px",
                  // height: '45px',
                  // fontWeight: "var(--font_weight_2) !important",
                  fontSize: "14px !important",
                  display: "flex",
                  // margin: { xs: "auto", md: "0" },
                }}
                variantType={EnvConfig.PRIMARY_BUTTON_TYPE}
                onClick={() => checkCoverageHandler(coverageAddress)}
                disabled={checkDisableHandler()}
                loading={coverageLoading}
              >
                {button_1}
              </ButtonCust>
            </>
          ) : (
            <>
              <Box
                component={"img"}
                src={tick_icon?.data.attributes.url}
                alt={tick_icon?.data.attributes.alternativeText}
              />
              <Typography
                variant="h5"
                sx={{
                  my: "15px",
                  textAlign: "center",
                  color: "var(--title-color_1)",
                  fontFamily: "var(--font_family_Bold) !important",
                  fontSize: "24px",
                  width: { xs: "100%", md: "60%" },
                }}
              >
                {BrandNameUpdate(modal_heading2)}
              </Typography>

              {signal4G !== "no service" || signal5G !== "no service" ? (
                <Container
                  sx={{
                    display: "flex",
                    justifyContent: "space-around",
                    width: "100%",
                    mt: "25px",
                  }}
                >
                  <Container
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Box
                      component="div"
                      sx={{
                        marginRight: "5px",
                        minWidth: "35px",
                        "& svg": {
                          width: "60px",
                          height: "42px",
                        },
                      }}
                      dangerouslySetInnerHTML={{
                        __html: updateSvgFillColor(
                          signal4G === "fair"
                            ? fair_signal_code
                            : signal4G === "good"
                            ? good_signal_code
                            : signal4G === "great"
                            ? great_signal_code
                            : no_signal_code,
                          "var(--primary_color)"
                        ),
                      }}
                    />
                  </Container>
                  <Container
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Box
                      component="div"
                      sx={{
                        marginRight: "5px",
                        minWidth: "35px",
                        "& svg": {
                          width: "60px",
                          height: "42px",
                        },
                      }}
                      dangerouslySetInnerHTML={{
                        __html: updateSvgFillColor(
                          signal5G === "fair"
                            ? fair_signal_code
                            : signal5G === "good"
                            ? good_signal_code
                            : signal5G === "great"
                            ? great_signal_code
                            : no_signal_code,
                          "var(--primary_color)"
                        ),
                      }}
                    />
                  </Container>
                </Container>
              ) : (
                <Box
                  component="div"
                  sx={{
                    marginRight: "5px",
                    minWidth: "35px",
                    "& svg": {
                      width: "60px",
                      height: "42px",
                    },
                  }}
                  dangerouslySetInnerHTML={{
                    __html: updateSvgFillColor(
                      no_signal_code,
                      "var(--primary_color)"
                    ),
                  }}
                />
              )}

              {signal4G !== "no service" || signal5G !== "no service" ? (
                <Container
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-around",
                    my: 2.5,
                  }}
                  className={styles.coverage_final_text}
                >
                  <Typography
                    variant="subtitle1"
                    component={"span"}
                    sx={{
                      fontSize: "16px",
                      fontFamily: "var(--font_family_Regular)",
                      textAlign: "center",
                    }}
                  >
                    {coverage_1}{" "}
                    {signal4G === "fair"
                      ? signal_strength1
                      : signal4G === "good"
                      ? signal_strength2
                      : signal4G === "great"
                      ? signal_strength3
                      : signal_strength4}
                  </Typography>
                  <Typography
                    variant="subtitle1"
                    component={"span"}
                    sx={{
                      fontSize: "16px",
                      fontFamily: "var(--font_family_Regular)",
                      textAlign: "center",
                    }}
                  >
                    {coverage_2}{" "}
                    {signal5G === "fair"
                      ? signal_strength1
                      : signal5G === "good"
                      ? signal_strength2
                      : signal5G === "great"
                      ? signal_strength3
                      : signal_strength4}
                  </Typography>
                </Container>
              ) : (
                <Container
                  sx={{ textAlign: "center", my: 2.5 }}
                  className={styles.coverage_final_text}
                >
                  {signal_note2}
                </Container>
              )}
              <ButtonCust
                sx={{ my: 0.75, width: "100%", maxWidth: "250px" }}
                className={styles.detailed_coverage}
                onClick={navigateCheckCoverage}
                variantType={EnvConfig.PRIMARY_BUTTON_TYPE}
              >
                {button_5}
              </ButtonCust>
              {signal4G !== "no service" || signal5G !== "no service" ? (
                <Typography
                  variant="subtitle1"
                  sx={{ mt: "15px" }}
                  className={styles.detailed_coverage}
                  onClick={searchAgainHandler}
                >
                  {button_2}
                </Typography>
              ) : (
                ""
              )}
              <Typography
                variant="subtitle1"
                sx={{ mb: "10px" }}
                className={styles.detailed_coverage}
                onClick={exploreHandler}
              >
                {signal4G !== "no service" || signal5G !== "no service"
                  ? button_3
                  : button_4}
              </Typography>
            </>
          )}
        </SimpleModal>
      </>
    )
  );
};

export default T8CheckCoverageComponent;
